import { render, staticRenderFns } from "./ExperiencedAndProfessionalTeam.vue?vue&type=template&id=e544f54e&scoped=true"
import script from "./ExperiencedAndProfessionalTeam.vue?vue&type=script&lang=js"
export * from "./ExperiencedAndProfessionalTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e544f54e",
  null
  
)

export default component.exports